import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { reportsApi } from '../api/reports.js';
import { ErrorBox } from './ui.js';

/**
 * 표 안에서 바로 고치는 메모 (원본 realdoll_list.php 의 행마다 있던
 * textarea + [메모입력] 버튼). report.registry.ts 에 memoEdit 를 정의한
 * 리포트라면 어디서든 쓸 수 있다 (ReportPage.tsx, SalesAnalysisPage.tsx 등).
 *
 * 서버 값을 useEffect 로 다시 받아쓰지 않는다 - 저장하면 같은 리포트 쿼리가
 * 통째로 refetch 되는데, 그때 다른 행에서 아직 저장 안 한 입력까지 지워버리면
 * 안 된다. 이 행 자신의 draft 는 이 행 자신이 저장했을 때만 지운다.
 */
export function MemoCell({
  reportId,
  pk,
  value,
  onSaved,
}: {
  reportId: string;
  pk: string | number;
  value: string;
  onSaved: () => void;
}) {
  const [draft, setDraft] = useState<string | null>(null);
  const text = draft ?? value;

  const save = useMutation({
    mutationFn: () => reportsApi.saveMemo(reportId, pk, text),
    onSuccess: () => {
      setDraft(null);
      onSaved();
    },
  });

  const dirty = draft !== null && draft !== value;
  return (
    <div className="inline-edit">
      <textarea
        className="input input--area"
        rows={2}
        value={text}
        onChange={(e) => setDraft(e.target.value)}
      />
      {dirty && (
        <button
          type="button"
          className="btn btn--sm"
          disabled={save.isPending}
          onClick={() => save.mutate()}
        >
          {save.isPending ? '저장 중…' : '저장'}
        </button>
      )}
      {save.isError && <ErrorBox error={save.error} />}
    </div>
  );
}
